// Horizontal scroll animation for vendi-con-noi-icone-num
function initHorizontalScrollAnimation() {
    const targetDiv = document.querySelector('.scrolling-anim');

    if (!targetDiv) {
        console.warn('Element scrolling-anim not found');
        return;
    }

    let animationId = null;
    let isScrolling = false;
    let scrollDirection = 1; // 1 for right, -1 for left
    let currentScroll = 0;

    // Configuration
    const scrollSpeed = 0.5; // pixels per frame (adjust for speed)
    const pauseDuration = 2000; // pause at ends in milliseconds
    let pauseStart = null;
    let isPaused = false;

    // Intersection Observer to detect when element enters viewport
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting && !isScrolling) {
                startScrollAnimation();
            } else if (!entry.isIntersecting && isScrolling) {
                stopScrollAnimation();
            }
        });
    }, {
        threshold: 0.3 // Trigger when 30% of the element is visible
    });

    function startScrollAnimation() {
        if (isScrolling) return;

        isScrolling = true;
        currentScroll = targetDiv.scrollLeft;
        animate();
    }

    function stopScrollAnimation() {
        if (animationId) {
            cancelAnimationFrame(animationId);
            animationId = null;
        }
        isScrolling = false;
        isPaused = false;
        pauseStart = null;
    }

    function animate() {
        if (!isScrolling) return;

        const maxScroll = targetDiv.scrollWidth - targetDiv.clientWidth;

        // Handle pausing at the ends
        if (isPaused) {
            if (Date.now() - pauseStart >= pauseDuration) {
                isPaused = false;
                pauseStart = null;
            } else {
                animationId = requestAnimationFrame(animate);
                return;
            }
        }

        // Calculate new scroll position
        currentScroll += scrollSpeed * scrollDirection;

        // Check boundaries and reverse direction if needed
        if (currentScroll >= maxScroll) {
            currentScroll = maxScroll;
            scrollDirection = -1; // Start scrolling left
            isPaused = true;
            pauseStart = Date.now();
        } else if (currentScroll <= 0) {
            currentScroll = 0;
            scrollDirection = 1; // Start scrolling right
            isPaused = true;
            pauseStart = Date.now();
        }

        // Apply the scroll
        targetDiv.scrollLeft = currentScroll;

        // Continue animation
        animationId = requestAnimationFrame(animate);
    }

    // Start observing the target element
    observer.observe(targetDiv);

    // Optional: Stop animation when page becomes hidden
    document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
            stopScrollAnimation();
        } else if (targetDiv && isElementInViewport(targetDiv)) {
            startScrollAnimation();
        }
    });

    // Utility function to check if element is in viewport
    function isElementInViewport(el) {
        const rect = el.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHorizontalScrollAnimation);
} else {
    initHorizontalScrollAnimation();
}
